export const CONTRACTS = {
  vault: '0xF2C1164499D6AaB1b0ddc9a7349e7827efD882Bc',
  usdc: '0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238',
  strategy: '0xa2BB571a3eB292aE4bc87C6dd12EF85DD36E70aa'
};

export const CHAIN_ID = 11155111; 